module.exports = __webpack_public_path__ + "media/ubud/waterfall-7fd9e60c.jpg";